export default function PageHeader({ eyebrow, title, description, icon: Icon, action }) {
  return (
    <div className="border-b border-zinc-800 bg-[#0C0E12] px-4 sm:px-8 py-4 sm:py-6 sticky top-0 z-10 sadcr-fade">
      <div className="flex flex-col lg:flex-row lg:items-start gap-4">
        {Icon && (
          <div className="h-11 w-11 grid place-items-center bg-primary/10 border border-primary/30 rounded-sm shrink-0">
            <Icon className="h-5 w-5 text-primary" />
          </div>
        )}
        <div className="min-w-0">
          {eyebrow && (
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-1">
              {eyebrow}
            </div>
          )}
          <h1 className="font-heading text-2xl sm:text-3xl font-black uppercase tracking-tight text-zinc-100">
            {title}
          </h1>
          {description && <p className="text-sm text-zinc-500 mt-1">{description}</p>}
        </div>
        {action && <div className="lg:ml-auto lg:shrink-0 w-full lg:w-auto overflow-x-auto">{action}</div>}
      </div>
    </div>
  );
}
